'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LandingLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _reactRouter = require('react-router');

var _globalFooter = require('../../components/globalFooter');

var _basicLayout = require('../basicLayout');

var _sider = require('../../components/sider');

var _header = require('../../components/header');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Brand(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      description = _ref.description,
      Link = _ref.Link;

  return _react2.default.createElement(
    'div',
    { className: 'j-top' },
    _react2.default.createElement(
      'div',
      { className: 'j-header' },
      _react2.default.createElement(
        Link,
        { to: '/' },
        _react2.default.createElement('img', { alt: '', className: 'j-logo', src: logo }),
        _react2.default.createElement(
          'span',
          { className: 'j-title' },
          title
        )
      )
    ),
    description ? _react2.default.createElement(
      'p',
      { className: 'j-desc' },
      description
    ) : null
  );
}

var LandingLayout = exports.LandingLayout = (_temp = _class = function (_BasicLayout) {
  _inherits(LandingLayout, _BasicLayout);

  function LandingLayout() {
    _classCallCheck(this, LandingLayout);

    return _possibleConstructorReturn(this, (LandingLayout.__proto__ || Object.getPrototypeOf(LandingLayout)).apply(this, arguments));
  }

  _createClass(LandingLayout, [{
    key: 'render',
    value: function render() {
      var Footer = this.getComponent('Footer');
      var BLink = this.getComponent('Link');
      var Brand = this.getComponent('Brand');
      var Header = this.getComponent('Header');
      var style = this.props.style || { padding: '110px 0 144px' };
      return _react2.default.createElement(
        'div',
        { className: 'j-layout-landing ' + this.props.className, style: style },
        _react2.default.createElement(
          _layout2.default,
          null,
          _react2.default.createElement(Header, { noSider: true, Menu: _sider.Sider }),
          _react2.default.createElement(
            _layout2.default.Content,
            null,
            _react2.default.createElement(Brand, { Link: BLink }),
            this.props.viewContent || this.props.children,
            _react2.default.createElement(Footer, { className: 'j-footer' })
          )
        )
      );
    }
  }]);

  return LandingLayout;
}(_basicLayout.BasicLayout), _class.displayName = 'LandingLayout', _class.layoutBlocks = {
  Footer: _globalFooter.GlobalFooter,
  Link: _reactRouter.Link,
  Brand: Brand,
  Header: _header.Header
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layouts/landingLayout/index.jsx
// module id = 54
// module chunks = 0